// extracted by mini-css-extract-plugin
module.exports = {"info":"anti-fraud_info__1vou9"};